import React from 'react';
import { Navigate } from 'react-router-dom';

const SubscriptionInfo = () => {
    return <Navigate to="/subscription" replace />;
};

export default SubscriptionInfo;
